export default "__VITE_ASSET__HGo5XevB__"